import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageSquare, MapPin, ArrowRight } from 'lucide-react';
import company from '../data/company';
import { generateGeneralWhatsAppLink } from '../data/products';

const Footer = () => {
  return (
    <footer style={{ background: '#f8fafc', borderTop: '1px solid rgba(15,23,42,0.08)', overflow: 'hidden' }}>

      {/* ── PRE-FOOTER CTA BANNER ── */}
      <div style={{
        borderBottom: '1px solid rgba(15,23,42,0.08)',
        background: 'linear-gradient(135deg, #f1f5f9 0%, rgba(224,0,135,0.07) 100%)',
        padding: 'clamp(48px, 8vw, 80px) 0'
      }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="section-badge">START YOUR SOURCING JOURNEY</span>
          <h2 style={{
            fontSize: 'clamp(22px, 4vw, 42px)',
            fontFamily: 'var(--font-heading)',
            fontWeight: 900,
            textTransform: 'uppercase',
            marginBottom: '14px',
            color: 'var(--text-main)',
            lineHeight: 1.1,
            marginTop: '4px'
          }}>
            READY TO DISCUSS YOUR <span className="gradient-text">DENIM REQUIREMENT?</span>
          </h2>
          <p style={{
            fontSize: 'clamp(14px, 1.6vw, 17px)',
            color: 'var(--text-muted)',
            maxWidth: '560px',
            margin: '0 auto 32px',
            lineHeight: 1.6
          }}>
            Whether you buy for a mall, MBO, retail chain, importer, distributor, or apparel brand, let's discuss your denim sourcing and export requirements.
          </p>
          <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href={generateGeneralWhatsAppLink('Export Enquiry')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
              style={{ padding: '13px 26px' }}
            >
              <MessageSquare size={16} />
              WHATSAPP US
            </a>
            <Link to="/contact" className="btn-primary" style={{ padding: '13px 26px' }}>
              SEND AN ENQUIRY
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>

      {/* ── MAIN FOOTER BODY ── */}
      <div style={{ padding: 'clamp(40px, 6vw, 72px) 0 0' }}>
        <div className="container">

          {/* ── FOOTER GRID ── */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 'clamp(28px, 4vw, 48px)',
            marginBottom: 'clamp(36px, 5vw, 56px)'
          }}>

            {/* COL 1: Brand */}
            <div style={{ gridColumn: 'span 1' }}>
              <div style={{ marginBottom: '18px' }}>
                <img
                  src="/Rayyandenimlogo.jpeg"
                  alt="RAYYAN DENIM"
                  style={{
                    height: 'clamp(52px, 7vw, 72px)',
                    width: 'auto',
                    objectFit: 'contain',
                    borderRadius: '6px'
                  }}
                />
              </div>
              <p style={{ fontSize: '13px', lineHeight: 1.65, color: 'var(--text-muted)', marginBottom: '10px' }}>
                {company.tagline}
              </p>
              <p style={{ fontSize: '12px', color: 'var(--text-subtle)', lineHeight: 1.55 }}>
                INTERNATIONAL,CORPORATE DENIM EXPORTER.
              </p>
            </div>

            {/* COL 2: Company links */}
            <div>
              <h4 style={{
                fontSize: '11px', letterSpacing: '0.12em', color: 'var(--text-main)',
                marginBottom: '16px', textTransform: 'uppercase', fontWeight: 800
              }}>
                COMPANY
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {[
                  { label: 'About RAYYAN', path: '/about' },
                  { label: 'Collections', path: '/collections' },
                  { label: 'Export Network', path: '/export' },
                  { label: 'Distributorship', path: '/distributorship' },
                  { label: 'Global Corporate', path: '/global-business' },
                  { label: 'Contact Us', path: '/contact' }
                ].map(({ label, path }) => (
                  <li key={label}>
                    <Link to={path} style={{ color: 'var(--text-muted)', fontSize: '13px', transition: 'color 0.2s' }}
                      onMouseEnter={e => e.target.style.color = 'var(--accent-magenta)'}
                      onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
                    >{label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* COL 3: Corporate */}
            <div>
              <h4 style={{
                fontSize: '11px', letterSpacing: '0.12em', color: 'var(--text-main)',
                marginBottom: '16px', textTransform: 'uppercase', fontWeight: 800
              }}>
                CORPORATE
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {[
                  'International Buyers', 'Importers & Overseas Buyers',
                  'Global Distributors', 'Retail Chains & Malls'
                ].map((item) => (
                  <li key={item}>
                    <Link to="/global-business" style={{ color: 'var(--text-muted)', fontSize: '13px', transition: 'color 0.2s' }}
                      onMouseEnter={e => e.target.style.color = 'var(--accent-magenta)'}
                      onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
                    >{item}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* COL 4: Contact */}
            <div>
              <h4 style={{
                fontSize: '11px', letterSpacing: '0.12em', color: 'var(--text-main)',
                marginBottom: '16px', textTransform: 'uppercase', fontWeight: 800
              }}>
                CONTACT
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <a
                  href={`tel:${company.phone}`}
                  style={{ display: 'flex', alignItems: 'center', gap: '9px', color: 'var(--text-muted)', fontSize: '13px' }}
                >
                  <Phone size={14} style={{ color: 'var(--accent-magenta)', flexShrink: 0 }} />
                  {company.phone}
                </a>
                <a
                  href={`mailto:${company.email}`}
                  style={{ display: 'flex', alignItems: 'center', gap: '9px', color: 'var(--text-muted)', fontSize: '13px' }}
                >
                  <Mail size={14} style={{ color: 'var(--accent-magenta)', flexShrink: 0 }} />
                  {company.email}
                </a>
                <a
                  href={generateGeneralWhatsAppLink('Export Enquiry')}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '9px', color: '#25d366', fontSize: '13px', fontWeight: 700 }}
                >
                  <MessageSquare size={14} style={{ flexShrink: 0 }} />
                  Export Enquiry
                </a>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '9px' }}>
                  <MapPin size={14} style={{ color: 'var(--accent-magenta)', flexShrink: 0, marginTop: '2px' }} />
                  <span style={{ fontSize: '12px', color: 'var(--text-subtle)', lineHeight: 1.55 }}>
                    {company.address}
                  </span>
                </div>
              </div>
            </div>

            {/* COL 5: Social */}
            <div>
              <h4 style={{
                fontSize: '11px', letterSpacing: '0.12em', color: 'var(--text-main)',
                marginBottom: '16px', textTransform: 'uppercase', fontWeight: 800
              }}>
                FOLLOW
              </h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {[
                  {
                    href: company.socials.instagram, label: 'Instagram',
                    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
                  },
                  {
                    href: company.socials.youtube, label: 'YouTube',
                    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" /><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" /></svg>
                  },
                  {
                    href: company.socials.facebook, label: 'Facebook',
                    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
                  },
                  {
                    href: company.socials.linkedin, label: 'LinkedIn',
                    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
                  }
                ].map(({ href, label, icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    style={{
                      width: '38px', height: '38px',
                      borderRadius: '8px',
                      background: '#ffffff',
                      border: '1px solid var(--color-border)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: 'var(--text-muted)',
                      boxShadow: '0 1px 6px rgba(15,23,42,0.04)',
                      transition: 'border-color 0.2s, color 0.2s, transform 0.2s'
                    }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent-magenta)'; e.currentTarget.style.color = 'var(--accent-magenta)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.transform = 'none'; }}
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* ── BOTTOM BAR ── */}
          <div style={{
            paddingTop: '24px',
            paddingBottom: '28px',
            borderTop: '1px solid rgba(15,23,42,0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '10px',
            fontSize: '12px',
            color: 'var(--text-subtle)'
          }}>
            <div>© {new Date().getFullYear()} <span className="brand-name">RAYYAN DENIM</span>. All Rights Reserved.</div>
            <div>International Denim Export &amp; Distributorship · Bhavnagar, Gujarat, India</div>
          </div>
        </div>
      </div>

      {/* Footer responsive overrides */}
      <style>{`
        @media (max-width: 768px) {
          footer .footer-bottom-bar {
            flex-direction: column !important;
            text-align: center !important;
          }
        }
        @media (max-width: 640px) {
          footer > div:last-child > div > div:first-child {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 420px) {
          footer > div:last-child > div > div:first-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
